import React from 'react';
import { Card, Form, Input, Select, DatePicker, Row, Col, Space, Button, Tag, Popconfirm } from 'antd';
import { SaveOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Supplier, Warehouse } from '../../../../services/supplyChainService';

interface POHeaderFormProps {
    isNew: boolean;
    currentStatus: string;
    suppliers: Supplier[];
    warehouses: Warehouse[];
    submitting: boolean;
    onSave: () => void;
    onApprove: () => void;
    onReceive: () => void;
    poNumber: string;
}

const { Option } = Select;

export const POHeaderForm: React.FC<POHeaderFormProps> = ({
    isNew, currentStatus, suppliers, warehouses, submitting,
    onSave, onApprove, onReceive, poNumber
}) => {
    return (
        <Card
            title={isNew ? "新建采购单" : `采购单: ${poNumber}`}
            extra={
                <Space>
                    <Tag color={currentStatus === 'received' ? 'green' : 'orange'}>{currentStatus.toUpperCase()}</Tag>
                    {currentStatus !== 'received' && (
                        <Button type="primary" icon={<SaveOutlined />} onClick={onSave} loading={submitting}>保存</Button>
                    )}
                    {!isNew && (currentStatus === 'draft' || currentStatus === 'approval') && (
                        <Popconfirm title="确认审核通过？状态将变更为已下单。" onConfirm={onApprove}>
                            <Button type="default" loading={submitting} style={{ borderColor: '#1890ff', color: '#1890ff' }}>审核通过</Button>
                        </Popconfirm>
                    )}
                    {!isNew && currentStatus !== 'received' && (
                        <Popconfirm title="确认全部到货并入库？此操作将生成库存批次并增加系统库存。" onConfirm={onReceive}>
                            <Button type="primary" icon={<CheckCircleOutlined />} loading={submitting} style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>确认入库</Button>
                        </Popconfirm>
                    )}
                </Space>
            }
        >
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item name="po_number" label="采购单号" rules={[{ required: true }]}>
                        <Input disabled={!isNew} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="supplier" label="供应商" rules={[{ required: true }]}>
                        <Select placeholder="选择供应商" disabled={currentStatus === 'received'}>
                            {(Array.isArray(suppliers) ? suppliers : []).map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="target_warehouse" label="目标仓库" rules={[{ required: true }]}>
                        <Select placeholder="选择入库仓库" disabled={currentStatus === 'received'}>
                            {(Array.isArray(warehouses) ? warehouses : []).map(w => <Option key={w.id} value={w.id}>{w.name}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="order_date" label="下单日期">
                        <DatePicker style={{ width: '100%' }} disabled={currentStatus === 'received'} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={6}>
                    <Form.Item name="expected_arrival_date" label="预计到货">
                        <DatePicker style={{ width: '100%' }} disabled={currentStatus === 'received'} />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item name="currency" label="币种">
                        <Select disabled={currentStatus === 'received'}>
                            <Option value="CNY">CNY</Option>
                            <Option value="USD">USD</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="notes" label="备注">
                        <Input placeholder="订单备注" disabled={currentStatus === 'received'} />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};
